<template lang="pug">
  .columns
    .column.is-3
      TbInventarioFisicos(:data="esferasIRGE")
      TbCapacidadDisponible(:data="esferasIRGE")
      TbProductoEntregado(:fecha="fecha" :data="documentacionIRGE")
      TbProductoRecibido(:data="patinEB00")
    .column.is-offset-1.is-8
      TbCumplimiento(:dataMetaMensual="dataMetaMensual" :data="dataCumplimiento" :fecha="fecha")
      TbEstimadoMes(:dataMetaMensual="dataMetaMensual" :data="dataCumplimiento" :fecha="fecha")
      Grafica(:chart-data="dataGrafica" :options="options" :height="300" :width="600")
</template>

<script>
  import TbInventarioFisicos from './Tb_InventariosFisicos.vue'
  import TbCumplimiento from './Tb_Cumplimiento.vue'
  import TbProductoEntregado from './Tb_ProductoEntregado.vue'
  import TbProductoRecibido from './Tb_ProductoRecibido.vue'
  import TbCapacidadDisponible from './Tb_CapacidadDisponible.vue'
  import TbEstimadoMes from './Tb_EstimadoMes.vue'
  import Grafica from './Grafica.vue'
  export default {
    name: 'Dashboard',
    props: {
      patinEB00: {
        type: Array,
        default: [],
      },
      esferasIRGE: {
        type: Array,
        default: [],
      },
      documentacionIRGE: {
        type: Object,
        default: () => {},
      },
      dataMetaMensual: {
        type: Array,
        default: [],
      },
      dataCumplimiento: {
        type: Object,
        default: () => {},
      },
      fecha: {
        type: String,
        default: () => '',
      },
      dataGrafica: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      TbInventarioFisicos,
      TbCumplimiento,
      TbCapacidadDisponible,
      TbProductoEntregado,
      TbProductoRecibido,
      TbEstimadoMes,
      Grafica,
    },
    data() {
      return {
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 5
                }
              }
            ]
          },
          plugins: {
            title: {
              display: true,
              text: 'Porcentaje de Cumplimiento - Julio',
            }
          }
        },
        myStyles: {
          height: '300px',
          position: 'relative'
        }
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/dashboard/componentes/Dashboard.vue